import { render } from "./MerchantList.vue?vue&type=template&id=08ee62e8&scoped=true"
import script from "./MerchantList.vue?vue&type=script&lang=js"
export * from "./MerchantList.vue?vue&type=script&lang=js"

import "./MerchantList.vue?vue&type=style&index=0&id=08ee62e8&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ee62e8"]])

export default __exports__